import { default as _91_46_46_46cms_931p69Pdqk6NMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_939abDUSnn1PMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexur7eQTlbKwMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93FlMoyNsKYQMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/akcii/[...slug].vue?macro=true";
import { default as indexr09tprmyUdMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93PAWwR92NiyMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/articles/[...slug].vue?macro=true";
import { default as indexGc22x6hDfvMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/articles/index.vue?macro=true";
import { default as index3OvOmeNzehMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/authorization/index.vue?macro=true";
import { default as indexUWokdG0X6nMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93BRkMEC0uHtMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93MdhN7V7dsRMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalog/[...slug].vue?macro=true";
import { default as indexNDD0H1quT2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93kxu8G3pqS1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalogsearch/[...slug].vue?macro=true";
import { default as result5jCOZIFH45Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalogsearch/result.vue?macro=true";
import { default as index6NK72WWNmxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93SEk8SBL1bxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93VkvMwoSpKuMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/fabriki/[...slug].vue?macro=true";
import { default as indexhhsfZGiiPxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93jh2R17UTjiMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_931Fx5Ae6p90Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/product/[...slug].vue?macro=true";
import { default as indexfX3LxunXSaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/profile/index.vue?macro=true";
import { default as index8G6aPg83mAMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/profile/orders/index.vue?macro=true";
import { default as indexHzHTBDrDQuMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93uiUPfVJkp4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/sets/[...slug].vue?macro=true";
import { default as indexSaOWmUV2eLMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_931p69Pdqk6NMeta?.name ?? "cms",
    path: _91_46_46_46cms_931p69Pdqk6NMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_931p69Pdqk6NMeta || {},
    alias: _91_46_46_46cms_931p69Pdqk6NMeta?.alias || [],
    redirect: _91_46_46_46cms_931p69Pdqk6NMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_939abDUSnn1PMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_939abDUSnn1PMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_939abDUSnn1PMeta || {},
    alias: _91_46_46_46slug_939abDUSnn1PMeta?.alias || [],
    redirect: _91_46_46_46slug_939abDUSnn1PMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexur7eQTlbKwMeta?.name ?? "3d-projects",
    path: indexur7eQTlbKwMeta?.path ?? "/3d-projects",
    meta: indexur7eQTlbKwMeta || {},
    alias: indexur7eQTlbKwMeta?.alias || [],
    redirect: indexur7eQTlbKwMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93FlMoyNsKYQMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93FlMoyNsKYQMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93FlMoyNsKYQMeta || {},
    alias: _91_46_46_46slug_93FlMoyNsKYQMeta?.alias || [],
    redirect: _91_46_46_46slug_93FlMoyNsKYQMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexr09tprmyUdMeta?.name ?? "akcii",
    path: indexr09tprmyUdMeta?.path ?? "/akcii",
    meta: indexr09tprmyUdMeta || {},
    alias: indexr09tprmyUdMeta?.alias || [],
    redirect: indexr09tprmyUdMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93PAWwR92NiyMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93PAWwR92NiyMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93PAWwR92NiyMeta || {},
    alias: _91_46_46_46slug_93PAWwR92NiyMeta?.alias || [],
    redirect: _91_46_46_46slug_93PAWwR92NiyMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexGc22x6hDfvMeta?.name ?? "articles",
    path: indexGc22x6hDfvMeta?.path ?? "/articles",
    meta: indexGc22x6hDfvMeta || {},
    alias: indexGc22x6hDfvMeta?.alias || [],
    redirect: indexGc22x6hDfvMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: index3OvOmeNzehMeta?.name ?? "authorization",
    path: index3OvOmeNzehMeta?.path ?? "/authorization",
    meta: index3OvOmeNzehMeta || {},
    alias: index3OvOmeNzehMeta?.alias || [],
    redirect: index3OvOmeNzehMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexUWokdG0X6nMeta?.name ?? "cart",
    path: indexUWokdG0X6nMeta?.path ?? "/cart",
    meta: indexUWokdG0X6nMeta || {},
    alias: indexUWokdG0X6nMeta?.alias || [],
    redirect: indexUWokdG0X6nMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93BRkMEC0uHtMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93BRkMEC0uHtMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93BRkMEC0uHtMeta || {},
    alias: _91_46_46_46id_93BRkMEC0uHtMeta?.alias || [],
    redirect: _91_46_46_46id_93BRkMEC0uHtMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93MdhN7V7dsRMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93MdhN7V7dsRMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93MdhN7V7dsRMeta || {},
    alias: _91_46_46_46slug_93MdhN7V7dsRMeta?.alias || [],
    redirect: _91_46_46_46slug_93MdhN7V7dsRMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexNDD0H1quT2Meta?.name ?? "catalog",
    path: indexNDD0H1quT2Meta?.path ?? "/catalog",
    meta: indexNDD0H1quT2Meta || {},
    alias: indexNDD0H1quT2Meta?.alias || [],
    redirect: indexNDD0H1quT2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93kxu8G3pqS1Meta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93kxu8G3pqS1Meta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93kxu8G3pqS1Meta || {},
    alias: _91_46_46_46slug_93kxu8G3pqS1Meta?.alias || [],
    redirect: _91_46_46_46slug_93kxu8G3pqS1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: result5jCOZIFH45Meta?.name ?? "catalogsearch-result",
    path: result5jCOZIFH45Meta?.path ?? "/catalogsearch/result",
    meta: result5jCOZIFH45Meta || {},
    alias: result5jCOZIFH45Meta?.alias || [],
    redirect: result5jCOZIFH45Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: index6NK72WWNmxMeta?.name ?? "clear-page-slider",
    path: index6NK72WWNmxMeta?.path ?? "/clear-page-slider",
    meta: index6NK72WWNmxMeta || {},
    alias: index6NK72WWNmxMeta?.alias || [],
    redirect: index6NK72WWNmxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93SEk8SBL1bxMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93SEk8SBL1bxMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93SEk8SBL1bxMeta || {},
    alias: _91_46_46_46slug_93SEk8SBL1bxMeta?.alias || [],
    redirect: _91_46_46_46slug_93SEk8SBL1bxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93VkvMwoSpKuMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93VkvMwoSpKuMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93VkvMwoSpKuMeta || {},
    alias: _91_46_46_46slug_93VkvMwoSpKuMeta?.alias || [],
    redirect: _91_46_46_46slug_93VkvMwoSpKuMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexhhsfZGiiPxMeta?.name ?? "fabriki",
    path: indexhhsfZGiiPxMeta?.path ?? "/fabriki",
    meta: indexhhsfZGiiPxMeta || {},
    alias: indexhhsfZGiiPxMeta?.alias || [],
    redirect: indexhhsfZGiiPxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93jh2R17UTjiMeta?.name ?? "order-status-hash",
    path: _91hash_93jh2R17UTjiMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93jh2R17UTjiMeta || {},
    alias: _91hash_93jh2R17UTjiMeta?.alias || [],
    redirect: _91hash_93jh2R17UTjiMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_931Fx5Ae6p90Meta?.name ?? "product-slug",
    path: _91_46_46_46slug_931Fx5Ae6p90Meta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_931Fx5Ae6p90Meta || {},
    alias: _91_46_46_46slug_931Fx5Ae6p90Meta?.alias || [],
    redirect: _91_46_46_46slug_931Fx5Ae6p90Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexfX3LxunXSaMeta?.name ?? "profile",
    path: indexfX3LxunXSaMeta?.path ?? "/profile",
    meta: indexfX3LxunXSaMeta || {},
    alias: indexfX3LxunXSaMeta?.alias || [],
    redirect: indexfX3LxunXSaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: index8G6aPg83mAMeta?.name ?? "profile-orders",
    path: index8G6aPg83mAMeta?.path ?? "/profile/orders",
    meta: index8G6aPg83mAMeta || {},
    alias: index8G6aPg83mAMeta?.alias || [],
    redirect: index8G6aPg83mAMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexHzHTBDrDQuMeta?.name ?? "recently",
    path: indexHzHTBDrDQuMeta?.path ?? "/recently",
    meta: indexHzHTBDrDQuMeta || {},
    alias: indexHzHTBDrDQuMeta?.alias || [],
    redirect: indexHzHTBDrDQuMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93uiUPfVJkp4Meta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93uiUPfVJkp4Meta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93uiUPfVJkp4Meta || {},
    alias: _91_46_46_46slug_93uiUPfVJkp4Meta?.alias || [],
    redirect: _91_46_46_46slug_93uiUPfVJkp4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexSaOWmUV2eLMeta?.name ?? "wishlist",
    path: indexSaOWmUV2eLMeta?.path ?? "/wishlist",
    meta: indexSaOWmUV2eLMeta || {},
    alias: indexSaOWmUV2eLMeta?.alias || [],
    redirect: indexSaOWmUV2eLMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260924093232/pages/wishlist/index.vue").then(m => m.default || m)
  }
]